import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MicrosoftPstnCallUsageReport } from '../../../shared/models/generated/ziroModels';
import { FileDownloadService } from '../../../shared/services/file-download.service';

@Injectable()
export class PstnCallingUsageReportResource {
  private $http = inject(HttpClient);
  private fileDownloadService = inject(FileDownloadService);

  get(tenantId: string): Observable<MicrosoftPstnCallUsageReport> {
    return this.$http.get<MicrosoftPstnCallUsageReport>(
      `/services/microsoft/reporting/tenants/${tenantId}/teams-pstn-call-usage`,
    );
  }

  export(tenantId: string): Observable<void> {
    return this.fileDownloadService.downloadFile(
      `/services/microsoft/reporting/tenants/${tenantId}/teams-pstn-call-usage/export`,
    );
  }
}
